import { headingStyles } from './components/heading';
import type { Util } from '../types/util';

/** Typography Paragraph Variants */
export type ParagraphVariantsType =
  | 'paragraph2XL300'
  | 'paragraphXL300'
  | 'paragraphL300'
  | 'paragraphM300'
  | 'paragraphS300'
  | 'paragraph2XL400'
  | 'paragraphXL400'
  | 'paragraphL400'
  | 'paragraphM400'
  | 'paragraphS400'
  | 'paragraphXS400';

type ParagraphVariants = Util.TypographyVariantObjects<ParagraphVariantsType, Util.TypographyObject>;

export const paragraphStyles: ParagraphVariants = {
  paragraph2XL300: {
    color: 'paragraph',
    fontSize: '2XL',
    fontWeight: 'light',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: 6,
  },
  paragraphXL300: {
    color: 'paragraph',
    fontSize: 'XL',
    fontWeight: 'light',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: 6,
  },
  paragraphL300: {
    color: 'paragraph',
    fontSize: 'L',
    fontWeight: 'light',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: 6,
  },
  paragraphM300: {
    color: 'paragraph',
    fontSize: 'M',
    fontWeight: 'light',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: '20px',
  },
  paragraphS300: {
    color: 'paragraph',
    fontSize: 'S',
    fontWeight: 'light',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: '20px',
  },
  paragraph2XL400: {
    color: 'paragraph',
    fontSize: '2XL',
    fontWeight: 'regular',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: 6,
  },
  paragraphXL400: {
    color: 'paragraph',
    fontSize: 'XL',
    fontWeight: 'regular',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: 6,
  },
  paragraphL400: {
    color: 'paragraph',
    fontSize: 'L',
    fontWeight: 'regular',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: 6,
  },
  paragraphM400: {
    color: 'paragraph',
    fontSize: 'M',
    fontWeight: 'regular',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: '20px',
  },
  paragraphS400: {
    color: 'paragraph',
    fontSize: 'S',
    fontWeight: 'regular',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: '20px',
  },
  paragraphXS400: {
    color: 'paragraph',
    fontSize: 'XS',
    fontWeight: 'regular',
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: '16px',
  },
};

export type LabelVariantsType = 'labelS700' | 'labelS400' | 'labelXS400' | 'labelXS500' | 'label2XS400' | 'label3XS400';

type LabelVariants = Util.TypographyVariantObjects<LabelVariantsType, Util.TypographyObject>;

export const labelStyles: LabelVariants = {
  labelS700: {
    color: 'label',
    fontSize: 'S',
    fontWeight: 'stronger',
    lineHeight: 'default',
    marginTop: 0,
    marginBottom: 3,
  },
  labelS400: {
    color: 'label',
    fontSize: 'S',
    fontWeight: 'regular',
    lineHeight: 'label',
    marginTop: 0,
    marginBottom: 3,
  },
  labelXS400: {
    color: 'label',
    fontSize: 'XS',
    fontWeight: 'regular',
    lineHeight: 'label',
    marginTop: 0,
    marginBottom: '12px',
  },
  labelXS500: {
    color: 'label',
    fontSize: 'XS',
    fontWeight: 'strong',
    lineHeight: 'label',
    marginTop: 0,
    marginBottom: '12px',
  },
  label2XS400: {
    color: 'label',
    fontSize: '2XS',
    fontWeight: 'regular',
    lineHeight: 'label',
    marginTop: 0,
    marginBottom: '12px',
  },
  label3XS400: {
    color: 'label',
    fontSize: '3XS',
    fontWeight: 'regular',
    lineHeight: 'label',
    marginTop: 0,
    marginBottom: '12px',
  },
};

type InteractiveVariantsType =
  | 'interactiveL400'
  | 'interactiveM400'
  | 'interactiveS400'
  | 'interactiveXS400'
  | 'interactiveL500'
  | 'interactiveM500'
  | 'interactiveS500'
  | 'interactiveXS500'
  | 'interactiveL700'
  | 'interactiveM700'
  | 'interactiveS700'
  | 'interactiveXS700';

type InteractiveVariants = Util.TypographyVariantObjects<InteractiveVariantsType, Util.TypographyObject>;

export const interactiveStyles: InteractiveVariants = {
  interactiveL400: {
    color: 'interactive',
    fontSize: 'L',
    fontWeight: 'regular',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: 4,
  },
  interactiveM400: {
    color: 'interactive',
    fontSize: 'M',
    fontWeight: 'regular',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: '20px',
  },
  interactiveS400: {
    color: 'interactive',
    fontSize: 'S',
    fontWeight: 'regular',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: 3,
  },
  interactiveXS400: {
    color: 'interactive',
    fontSize: 'XS',
    fontWeight: 'regular',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: '12px',
  },
  interactiveL500: {
    color: 'interactive',
    fontSize: 'L',
    fontWeight: 'strong',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: 4,
  },
  interactiveM500: {
    color: 'interactive',
    fontSize: 'M',
    fontWeight: 'strong',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: '20px',
  },
  interactiveS500: {
    color: 'interactive',
    fontSize: 'S',
    fontWeight: 'strong',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: 3,
  },
  interactiveXS500: {
    color: 'interactive',
    fontSize: 'XS',
    fontWeight: 'strong',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: '12px',
  },
  interactiveL700: {
    color: 'interactive',
    fontSize: 'L',
    fontWeight: 'stronger',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: 4,
  },
  interactiveM700: {
    color: 'interactive',
    fontSize: 'M',
    fontWeight: 'stronger',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: '20px',
  },
  interactiveS700: {
    color: 'interactive',
    fontSize: 'S',
    fontWeight: 'stronger',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: 3,
  },
  interactiveXS700: {
    color: 'interactive',
    fontSize: 'XS',
    fontWeight: 'stronger',
    lineHeight: 'interactive',
    marginTop: 0,
    marginBottom: '12px',
  },
};

export type TypographyVariantsType = ParagraphVariantsType | LabelVariantsType | InteractiveVariantsType;
export type BaseTypography = Util.TypographyVariantObjects<TypographyVariantsType, Util.TypographyObject>;

export const typographyVariants = Object.keys({
  ...paragraphStyles,
  ...labelStyles,
  ...interactiveStyles,
}) as TypographyVariantsType[];

const typographyStyles: BaseTypography = {
  ...paragraphStyles,
  ...labelStyles,
  ...interactiveStyles,
  ...headingStyles,
};
export type Typography = BaseTypography & Util.VariantModes<BaseTypography>;

const typography: Typography = {
  ...typographyStyles,
  products: {
    chart: typographyStyles,
    chartblog: typographyStyles,
    co: typographyStyles,
    edu: typographyStyles,
    scale: typographyStyles,
    spark: typographyStyles,
  },
};

export default typography;
